<template>
  <div
    :class="[
      'bg-surface-0 dark:bg-surface-900 border border-surface-200 dark:border-surface-700 rounded-lg',
      containerClass,
    ]"
    :data-test-id="testId"
  >
    <!-- Header -->
    <div
      :class="[
        'px-6 py-4 border-b border-surface-200 dark:border-surface-700 flex max-md:flex-col justify-between items-center gap-3',
        headerClass,
      ]"
    >
      <div class="flex items-center gap-3">
        <h4 class="text-md font-semibold text-surface-900 dark:text-surface-0">
          <slot name="title">{{ title }}</slot>
        </h4>
        <slot name="header-extra" />
      </div>
      <div class="flex items-center gap-2">
        <slot name="actions" />
      </div>
    </div>

    <!-- Content -->
    <div :class="['px-6 py-4', contentClass]">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  /**
   * Title text for the section panel header
   */
  title?: string

  /**
   * Optional data-test-id attribute for testing
   */
  testId?: string

  /**
   * Optional additional CSS classes for the container
   */
  containerClass?: string

  /**
   * Optional additional CSS classes for the header
   */
  headerClass?: string

  /**
   * Optional additional CSS classes for the content area
   */
  contentClass?: string
}

withDefaults(defineProps<Props>(), {
  title: '',
  testId: undefined,
  containerClass: '',
  headerClass: '',
  contentClass: '',
})
</script>
